import debounce from "lodash/debounce";
import { Toast } from 'antd-mobile';
import Cookies from 'js-cookie';
import tool from '@/common/utils/tool';

const win: any = window;

/**
 * 环境检测函数
 */
const getEnv = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isWebInWeapp = ua.includes('micromessenger');
  const isWeb = !ua.includes('mcd-ios') && !ua.includes('mcd-android') && !ua.includes('mcd-harmony');
  const isAlipay = ua.includes('alipay');
  const isIos = ua.includes('mcd-ios');
  const isAndroid = ua.includes('mcd-android');
  const isHarmony = ua.includes('mcd-harmony');
  const isApp = isIos || isAndroid || isHarmony;

  // console.log('getEnv', envInfo);
  return {
    isWebInWeapp,
    isWeb,
    isAlipay,
    isIos,
    isAndroid,
    isHarmony,
    isApp,
  }
};

/**
 * jsbridge连接函数
 */
const connectWebViewJavascriptBridge = (callback: any) => {
  if (win?.WebViewJavascriptBridge) {
    callback(win?.WebViewJavascriptBridge);
  } else {
    document.addEventListener('WebViewJavascriptBridgeReady', function () {
      callback(win?.WebViewJavascriptBridge);
    }, false);
  }
};

/**
 * 返回上一页
 */
const handleBack = () => {
  if(getEnv().isWebInWeapp) {
    // @ts-ignore
    window.wx.miniProgram.navigateBack();
  } else {
    connectWebViewJavascriptBridge((bridge: any) => {
      bridge.callHandler('closeWebView', '', () => ({}))
    });
  }
};

/**
 * 跳转卡包页
 */
const toCouponList = debounce((couponInfo: any)=>{
  if(getEnv().isWebInWeapp) {
    // @ts-ignore
    window.wx.miniProgram.navigateTo({
      url: '/coupon/pages/index'
    });
  } else {
    window.location.href =
    'mcdapp://page?iosPageName=MCDMyWalletHomeViewController&androidPageName=ComponentUser&androidPageAction=coupon_list&harmonyPageName=WalletPage&parameters=' + encodeURIComponent(JSON.stringify({couponId: couponInfo.couponId}));
  }
}, 1000, { leading: true, trailing: false })

const isLogin = () => {
  return !!getSid();
}

const getSid = () => {
  return Cookies.get('sid') || tool.getSearchByKey('sid');
}

/**
 * 跳转登录
 */
const toLogin = debounce(()=>{
  if(getEnv().isWebInWeapp) {
    // @ts-ignore
    window.wx.miniProgram.redirectTo({
      url: `/login/pages/authorize/index?url=${encodeURIComponent(window.location.href)}`
    });
  } else if(getEnv().isApp) {
    window.location.href = 'https://mcd.cn/login';
  }
}, 1000, { leading: true, trailing: false });

const downloadAtOnce = debounce(() => {
  if (getEnv().isHarmony) {
    Toast.show('请至应用市场下载麦当劳APP');
    return
  }
  const document: any = window.document;
  const hidden = document.hidden || document.mozHidden || document.msHidden || document.webkitHidden;
  if (!hidden) {
    let href;
    if (getEnv().isIos) {
      href = 'https://apps.apple.com/cn/app/id1054598922';
    } else {
      href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.mcdonalds.gma.cn';
    }
    window.location.href = href;
  }
}, 1000, { leading: true, trailing: false });

/**
 * 获取APP版本号
 */
const getAppVersion = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!getEnv().isApp) {
      reject(new Error('非APP环境'));
      return;
    }
    
    connectWebViewJavascriptBridge((bridge: any) => {
      bridge?.callHandler('getAppVersion', '', (responseData: any) => {
        try {
          resolve(JSON.parse(responseData).appVersion || '');
        } catch (error) {
          console.error('获取APP版本号失败:', error);
          resolve('');
        }
      });
    });
  });
};

/**
 * 向URL添加查询参数
 * @param url 原始URL
 * @param params 要添加的参数对象
 * @returns 添加参数后的URL
 */
const addQueryParams = (url: string, params: Record<string, string | number | boolean>): string => {
  try {
    const urlObj = new URL(url);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        urlObj.searchParams.set(key, String(value));
      }
    });
    return urlObj.toString();
  } catch (error) {
    console.error('URL参数添加失败:', error);
    return url;
  }
};

export {
  getEnv,
  connectWebViewJavascriptBridge,
  handleBack,
  toCouponList,
  toLogin,
  downloadAtOnce,
  getSid,
  isLogin,
  getAppVersion,
  addQueryParams,
};